// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2132":"59144a02","2549":"aa0c5fa2","3422":"aa0c5fa2","4058":"aa0c5fa2","8139":"aa0c5fa2","8140":"aa0c5fa2","8352":"aa0c5fa2"}[chunkId] + ".chunk.css";
};